module.exports = "<template id=\"perspective-d3fc-chart\">\r\n    <div id=\"container\" class=\"chart\">\r\n    </div>\r\n</template>";